<script lang="ts" setup>
import { useGlobalUser } from "./stores/globalUser";
import { useI18n } from "vue-i18n";
import { useGlobalInterval } from "@/stores/globalInterval";
import { onMounted, watch } from "vue";
import { useGlobalWindow } from "@/stores/globalWindow";
import { registerInterceptors } from "@/modules/request";
import { useRoute, useRouter } from "vue-router";
import "cropperjs/dist/cropper.css";
import { useReply } from "@/stores/reply";
import { setGalGameLanguage } from "@/locales";
import { usePushChannel } from "@/stores/push-channel";
import { listenToSWMessages } from "@/modules/message/clientMsg";
import { ClientMessage } from "@/modules/message/types/message.js";
import { ClientMessageEvent } from "@/modules/message/enums/message";
import DefaultLayout from "@/components/layout/DefaultLayout.vue";
import { StorageGet } from "./tools/localStorage";
import { useGlobalModal } from "./stores/globalModal";
import { inApp } from "./modules/common";
import { useJsBridgeStore } from "./stores/jsBridge";
import { useDebounceFn, useDocumentVisibility } from "@vueuse/core";
import { HOME_ROUTER } from "./use/go";

// 定义API错误类型
// interface ApiError {
//   response?: {
//     status?: number;
//   };
// }

const route = useRoute();
const router = useRouter();
registerInterceptors(route, router);
const { locale } = useI18n({ useScope: "global" });
const globalUser = useGlobalUser();
const modalStore = useGlobalModal();
const globalWindow = useGlobalWindow();
const pushChannel = usePushChannel();
const globalInterval = useGlobalInterval();
const jsBridgeStore = useJsBridgeStore();
jsBridgeStore.registerLoginStatusChangedHandler();
listenToSWMessages((message: ClientMessage) => {
  if (message.payload.event === ClientMessageEvent.WS_NOTIFICATION && inApp) {
    pushChannel.onNotification(message.payload.data!);
  }
});
onMounted(async () => {
  try {
    useReply().initEmojiVoteList();
    if (!globalUser.isInit) {
      await globalUser.init();
    }
  } catch (e: unknown) {
    globalWindow.showLoading = false;
  } finally {
    jsBridgeStore.callInitHandler();
    // 无论是否登录都需要初始化的数据
    if (globalUser.settingDisplayLanguageId === 1) {
      locale.value = "en-US";
    }

    if (globalUser.settingDisplayLanguageId === 2) {
      locale.value = "zh-CN";
    }
    setGalGameLanguage(locale.value);

    if (!globalUser.isLogin && !StorageGet(`AGREE_ENTER_APP`) && inApp) {
      modalStore.showEnterAppModal = true;
    }
  }
});

watch(
  () => globalUser.isLogin,
  (isLogin: boolean) => {
    if (isLogin) {
      globalInterval.registerInterval(true);
    } else {
      globalInterval.unregisterInterval();
    }
  },
  { immediate: true }
);

const visibility = useDocumentVisibility();
const debouncedVisibility = useDebounceFn(globalInterval.intervalTask, 1000);
watch(visibility, async (visibility, prevVisibility) => {
  if (
    visibility === "visible" &&
    prevVisibility === "hidden" &&
    globalUser.isLogin
  ) {
    await debouncedVisibility();
  }
});
</script>

<template>
  <DefaultLayout />
</template>
